
import React, { Component } from 'react';


export default class CustomIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: props.width? props.width : 32,
            height: props.height? props.height : 32,
        }
    }

    render() {
        return ( 
            <img src={this.props.path} width={this.state.width} height={this.state.height}></img>
        );
    }
}